import { css as _css } from "@emotion/react";
/** @jsx jsx */
import './side-panel.scss';
import { Button } from '@datacamp/waffles/button';
import { Cross } from '@datacamp/waffles/icon';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const SidePanel = _ref => {
  let {
    children,
    className,
    'data-testid': testId,
    icon,
    onClose,
    title,
    visible
  } = _ref;
  const {
    t
  } = useTranslation();
  return jsx("div", {
    className: visible ? className : 'dc-u-d-none',
    "data-testid": testId
  }, jsx("div", {
    className: "dc-u-fx dc-u-fx-jcsb dc-u-fx-aic dc-u-ph-12",
    css: /*#__PURE__*/_css({
      backgroundColor: tokens.colors.grey
    }, "production" === "production" ? "" : ";label:SidePanel;", "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  }, jsx("div", {
    className: "dc-u-fx dc-u-fx-jcs dc-u-fx-aic"
  }, icon, jsx("strong", {
    className: "dc-u-fs-h4 dc-u-ls-0 dc-u-pv-8 dc-u-mh-8"
  }, title)), jsx(Button, {
    "aria-label": t('common:close'),
    "data-testid": "side-panel-close-button-".concat(testId),
    "data-trackid": "side-panel-close-button-".concat(testId),
    icon: jsx(Cross, null),
    onClick: onClose,
    size: "small",
    style: {
      backgroundColor: 'transparent',
      color: tokens.colors.navy
    },
    variant: "plain"
  })), jsx("div", {
    className: "side-panel-body"
  }, children));
};